import React from "react";
import VideoCrop from "./VideoCrop";

export default function VideoCropModal({
    videoSrc,
    isOpen,
    onClose,
    onCropComplete,
    aspectRatios,
    allowedOrientations,
    lockedAspectRatio
}) {

    const handleCropComplete = (file, crop, trimStart, trimEnd, aspectRatioLabel) => {
        onCropComplete(file, crop, trimStart, trimEnd, aspectRatioLabel);
        onClose(false);
    };

    return (
        <VideoCrop
            videoSrc={videoSrc}
            isOpen={isOpen}
            onClose={(shouldClear = true) => onClose(shouldClear)}
            onCropComplete={handleCropComplete}
            aspectRatios={aspectRatios}
            allowedOrientations={allowedOrientations}
            lockedAspectRatio={lockedAspectRatio}
        />
    );
}
